<ng-container *ngIf="url">
  <div>
    <img *ngIf="type === 'IMG'" [src]="domain + url" alt="preview-img" class="preview-img" />
    <a (click)="$event.stopPropagation();" [href]="domain + url" target="_blank" download rel="noopener noreferrer"
      *ngIf="type === 'FILE'" class="preview-file d-flex text-body gap-2  align-items-center justify-content-center">
      <small class="{{fileTypeClass === 'img' ? 'aya-image' : 'aya-file-2'}} me-1 file_icon align-middle"></small>
      <small>
        ملف
      </small>
      <small>
        {{(fileType || '') | uppercase}}
      </small>
      <span class="aya-close-circle delete-icon" *ngIf="removable" (click)="_remove($event)">

      </span>
    </a>
  </div>
  <ng-content select="ngx-dropzone-label"></ng-content>
  <ngx-dropzone-remove-badge *ngIf="removable" (click)="_remove($event)">
  </ngx-dropzone-remove-badge>
</ng-container>

<div *ngIf="loading" style="z-index: 8;" class="position-absolute
                                   bg-secondary text-white bg-opacity-75 rounded-3 top-0 left-0 w-100
                                   d-flex align-items-center justify-content-center h-100 loading-spin">
  <span class="bx bx-loader bx-spin font-size-24"></span>
</div>
